import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Injector,
  Input,
  NgZone,
  OnInit,
  Output,
} from '@angular/core';
import {
  ContainerItemModel,
  ContainerModel,
  HourOption,
} from '@app/models/server/layout.model';
import {
  DecimalPipe,
  NgClass,
  NgOptimizedImage,
  NgStyle,
  NgTemplateOutlet,
  SlicePipe,
  TitleCasePipe,
} from '@angular/common';
import { Router } from '@angular/router';
import { AnalyticsEventService } from '@app/services/util-services/root-services/analytics-event-service';
import { WithinDateRangePipe } from '@app/components/pipes/within-date-range/within-date-range.pipe';
import { IsNotEmptyPipe } from '@app/components/pipes/is-not-empty/is-not-empty.pipe';
import { DateUtilLibModule } from '@b2b/date-util-lib';
import {
  COMP_STATES,
  FEATURE_TYPES,
  NEW_IMAGE_PLACEHOLDERS,
} from '@app/constants/app-settings';
import { B2bDesktopPromotion1StripComponent } from '@app/new-ui-lib/b2b-cards/components/b2b-desktop-property-card/b2b-desktop-promotion1-strip/b2b-desktop-promotion1-strip.component';
import { B2bDesktopPromotion2StripComponent } from '@app/new-ui-lib/b2b-cards/components/b2b-desktop-property-card/b2b-desktop-promotion2-strip/b2b-desktop-promotion2-strip.component';
import { convertObjectToQueryString } from '@app/services/util-services/convert-obj-to-query-string/convert-obj-to-query-string';
import { B2bDragScrollComponent } from '@app/new-ui-lib/b2b-drag-scroll/b2b-drag-scroll/b2b-drag-scroll.component';
import { B2bDragScrollItemComponent } from '@app/new-ui-lib/b2b-drag-scroll/b2b-drag-scroll-item/b2b-drag-scroll-item.component';
import { DragScrollType } from '@app/models/client/drag-scroll.type';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';
import { IntersectionObserverDirective } from '@app/components/directives/intersection-observer/intersection-observer.directive';
import { IntersectionStatus } from '@app/components/directives/intersection-observer/from-intersection-observer';
import { environment } from '@src/environments/environment';
import { SafePipe } from '@app/components/pipes/safe/safe.pipe';
import { TapEffect } from '@app/components/directives/tap-effect.ts/tap-effect';
import { LoaderUtilService } from '@app/services/loader/loader-util.service';
import { from } from 'rxjs';
import { ComponentRef, OverlayEventDetail } from '@ionic/core';
import { ModalController } from '@ionic/angular/standalone';

@Component({
  selector: 'app-b2b-property-card',
  templateUrl: './b2b-property-card.component.html',
  styleUrls: ['./b2b-property-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgClass,
    TitleCasePipe,
    NgTemplateOutlet,
    WithinDateRangePipe,
    IsNotEmptyPipe,
    DateUtilLibModule,
    B2bDesktopPromotion1StripComponent,
    B2bDesktopPromotion2StripComponent,
    B2bDragScrollComponent,
    B2bDragScrollItemComponent,
    NgOptimizedImage,
    DecimalPipe,
    IntersectionObserverDirective,
    NgStyle,
    SlicePipe,
    SafePipe,
    TapEffect,
  ],
})
export class B2bPropertyCardComponent implements OnInit {
  @Input() compData: {
    container: ContainerModel;
    loaded?: (value: any) => void;
    index?: number;
  };

  @Input() enableMapView: boolean;
  @Output() selectedPropertyEvent: EventEmitter<any> = new EventEmitter();

  FEATURE_TYPES = FEATURE_TYPES;
  featureTypes = [FEATURE_TYPES.SHORTSTAY, FEATURE_TYPES.EXTENDEDSTAY];
  placeHolderImage: string = NEW_IMAGE_PLACEHOLDERS?.hotel;
  F_TYPES = FEATURE_TYPES;
  swiperConfig: DragScrollType = {
    autoHeight: true,
    spaceBetween: 0,
    navigation: true,
    freeMode: false,
    mousewheel: false,
    grabCursor: false,
    pagination: true,
    slidesPerView: 2.9,
    centeredSlides: false,
    injectStyles: [],
    hideScrollButtons: false,
    showAbsoluteButtons: true,
  };

  isFavorite: boolean = Boolean(false);

  visibilityStatus: IntersectionStatus;

  intersectionStatus = IntersectionStatus;

  isServer: boolean = this.b2bDeviceUtilService.isServer();

  // pImage$: BehaviorSubject<string>;

  injector: Injector;

  cdref: ChangeDetectorRef;

  analyticsEventService: AnalyticsEventService;

  hostWebsite: string = environment.hostWebsite;

  imgQuality = 5;
  imgHeight = '170px';

  // isScrolled = false;

  // isScrolled$: BehaviorSubject<string>;

  constructor(
    private router: Router,
    private b2bDeviceUtilService: B2bDeviceUtilService,
    private ngZone: NgZone,
    private loaderUtilService: LoaderUtilService,
    private modalController: ModalController,
  ) {
    this.analyticsEventService = inject(AnalyticsEventService);
    this.cdref = inject(ChangeDetectorRef);
    this.injector = inject(Injector);
  }

  ngOnInit() {
    this.init();
  }

  enquriyNow() {
    this.openContactUsForm();
  }

  openContactUsForm() {
    from(
      import(
        '@app/new-ui-lib/b2b-cards/components/b2b-contact-us-form-card/b2b-contact-us-form-card.component'
      ).then((c) => c.B2bContactUsFormCardComponent),
    ).subscribe({
      next: async (componentRef: ComponentRef) => {
        const modal: HTMLIonModalElement = await this.modalController.create({
          component: componentRef,
          cssClass: 'enquiry-modal',
        });

        modal.onDidDismiss().then((result: OverlayEventDetail<any>) => {});

        return await modal.present();
      },
    });
  }

  init() {
    if (this.isServer) {
      this.initDataLoading();
    } else {
      this.ngZone.runOutsideAngular(() => {
        this.initDataLoading();
      });
    }
    if (this.compData?.container?.wishListedProperty) {
      this.isFavorite = true;
    }
    /*this.pImage$ = new BehaviorSubject<string>(
      this.compData?.container?.image?.path + '?format=webp&quality=5',
    );*/
  }

  initDataLoading() {
    if (this.compData?.loaded) {
      this.compData?.loaded(COMP_STATES?.LOADED);
    }
    if (this.compData?.container?.slidesInView) {
      this.swiperConfig.slidesPerView = this.compData?.container?.slidesInView;
    }
  }

  onSelectHour(selectedHour: HourOption) {
    if (!selectedHour?.active) {
      return;
    }
    this.onCardClick(selectedHour);
  }

  fireGoogleEvent() {
    this.analyticsEventService.fireAnalyticsEvent.emit({
      eventName: 'product_click',
      data: {
        name: this.compData?.container?.displayName,
        address: this.compData?.container?.description,
      },
    });
  }

  onCardClick(selectedHour: HourOption): void {
    if (this.compData?.container?.newNavigationURL) {
      this.loaderUtilService.show('Loading', { backdrop: true });
      this.fireGoogleEvent();
      this.selectedPropertyEvent.emit();
      const queryString: string = this.getQueryString(
        selectedHour?.queryParamKey,
        selectedHour?.hour,
      );
      let finalUrl: string = this.compData?.container?.newNavigationURL;
      finalUrl = `${finalUrl}?${queryString}`;
      this.router.navigateByUrl(finalUrl).then();
    }
  }

  getQueryString(key: string, value: any): string {
    let queryString: string;

    if (this.compData?.container?.queryParamObject) {
      const queryParamObject = JSON.parse(
        JSON.stringify(this.compData?.container?.queryParamObject),
      );
      if (value) {
        queryParamObject[key] = value;
      }
      queryString = convertObjectToQueryString(queryParamObject);
    }

    return queryString;
  }

  async openImageGallery() {
    /*if (
      !this.compData?.container?.allImages ||
      this.compData?.container?.allImages?.length === 0
    ) {
      return;
    }

    const finalContainer: ContainerModel = {
      data: this.compData?.container?.allImages?.map((item) => {
        return {
          image: item,
        };
      }),
    };*/

    const componentProps: {
      title: string;
      /**
       * @deprecated
       */
      containerItems?: ContainerItemModel[];
      container?: ContainerModel;
      showAllImages?: boolean;
      width: number;
      height: number;
    } = {
      title: 'All Images',
      containerItems: null,
      container: this.compData?.container,
      showAllImages: true,
      width: 355,
      height: 228,
    };

    import(
      '@app/services/util-services/lazy-services/open-gallery-util.service'
    ).then((r) => {
      const s = this.injector.get(r.OPEN_GALLERY_UTIL_SERVICE);
      s.openImageGallery(componentProps).then();
    });
  }

  async share() {
    import('@app/services/util-services/lazy-services/share-util.service').then(
      (r) => {
        const s = this.injector.get(r.SHARE_UTIL_SERVICE);
        s.openShareModal(
          this.compData?.container?.displayName,
          this.compData?.container?.description,
          this.compData?.container?.image?.path,
          this.compData?.container?.finalSeoUrl,
        ).then();
      },
    );
  }

  toggleFavorite() {
    import(
      '@app/services/util-services/lazy-services/wishlist-util.service'
    ).then((r) => {
      const s = this.injector.get(r.WISHLIST_UTIL_SERVICE);
      s.toggleFavorite(
        !this.isFavorite,
        this.compData?.container?.uid,
      ).subscribe((result: boolean) => {
        this.isFavorite = result;
        this.cdref.markForCheck();
      });
    });
  }

  onFeatureClick(featureType: string) {
    this.fireGoogleEvent();

    if (this.compData?.container?.newNavigationURL) {
      const queryString: string = this.getQueryString('ft', featureType);
      let finalUrl: string = this.compData?.container?.newNavigationURL;
      finalUrl = `${finalUrl}?${queryString}`;
      this.router.navigateByUrl(finalUrl).then();
    }
  }

  onVisibilityChanged(status: IntersectionStatus) {
    this.visibilityStatus = status;
    if (
      this.visibilityStatus === this.intersectionStatus?.Visible &&
      !this.isServer
    ) {
      let timeout = 500;
      if (this.compData?.index === 0) {
        timeout = 500;
      }
      setTimeout(() => {
        /*this.pImage$ = new BehaviorSubject<string>(
          this.compData?.container?.image?.path + '?format=webp&quality=90',
        );*/
        this.imgQuality = 90;
        this.imgHeight = '150px';
        this.cdref.markForCheck();
      }, timeout);
    }
  }

  protected readonly environment = environment;
}
